import { render } from "./PlaceSearch.vue?vue&type=template&id=61044b21&scoped=true&ts=true"
import script from "./PlaceSearch.vue?vue&type=script&lang=ts"
export * from "./PlaceSearch.vue?vue&type=script&lang=ts"

import "./PlaceSearch.vue?vue&type=style&index=0&id=61044b21&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61044b21"]])

export default __exports__